import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useLandingPages = (skip: number, limit: number, searchPhrase: string = "") => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.LANDING_PAGES(skip, limit, searchPhrase),
    queryFn: () => shopApi.fetchLandingPages(skip, limit, searchPhrase),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.LANDING_PAGES(skip, limit, searchPhrase),
    });
  };

  const invalidateAll = () => {
    queryClient.invalidateQueries({
      predicate: (query) => query.queryKey[0] === "landingPages",
    });
  };

  return {
    isLoading,
    isFetching,
    landingPages: data?.data.data ?? [],
    total: data?.data.total ?? 0,
    invalidate,
    invalidateAll,
  };
};
